import React from 'react';
import { createRoot } from 'react-dom/client';
import { AppRoutes } from './app/routing/AppRoutes';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import './main/assets/sass/style.scss'
import './main/assets/sass/plugins.scss'
import './main/assets/sass/style.react.scss'

import 'bootstrap/dist/css/bootstrap.min.css'; 

const container = document.getElementById('root')

if(container){
  createRoot(container).render(
    <>
      <AppRoutes />
      <ToastContainer />
    </>
  )
}
